module.exports = __webpack_public_path__ + "img/close.d0fa69c7.svg";